/* import __COLOCATED_TEMPLATE__ from './date.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface TasksKitListDateSignature {
  Args: {
    dueDateIdPrefix: unknown;
    entityResourceName: unknown;
    hideAddButton: unknown;
    isAutoResolvable: unknown;
    isLoading: unknown;
    newDisabled: unknown;
    onDelete: unknown;
    onDraft: unknown;
    onResolve: unknown;
    onSelect: unknown;
    onSubmit: unknown;
    readonlyTasks: unknown;
    resourceName: unknown;
    selectedTask: unknown;
    selectedView: unknown;
    taskResourceName: unknown;
    taskType: unknown;
    tasks: unknown;
  };
}

const TasksKitListDateComponent = templateOnlyComponent<TasksKitListDateSignature>();

export default TasksKitListDateComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::List::Date': typeof TasksKitListDateComponent;
    'tasks-kit/list/date': typeof TasksKitListDateComponent;
  }
}
